import { useEffect, useState } from 'react';

import { useCurrenciesStore } from '@/entities/currency';

import { useQueryFilteredPagination } from '@/shared/lib/hooks/use-query-pagination/useWithFilters';

import { transactionsQuery } from '../api/queries';
import { serializeTransaction } from '../lib/serialize';
import { ITransaction } from './types';

export const useTransactionsController = (accCurrency?: string) => {
  const [txsByAcc, setTxsByAcc] = useState<ITransaction[]>([]);
  const currencies = useCurrenciesStore((state) => state.currenciesById);
  const {
    data: transactions,
    search,
    onSearch,
    reset,
    isLoading,
    filters,
    setFilters,
    ...pagination
  } = useQueryFilteredPagination({
    queryKey: 'txs-list',
    queryFn: transactionsQuery,
    initialFilters: {},
    serialize: (txs) => txs.map((i) => serializeTransaction(i, currencies)),
  });

  useEffect(() => {
    if (accCurrency) {
      setTxsByAcc(transactions.filter((i) => i.sourceCurrency === accCurrency));
    }
  }, [accCurrency]);

  return {
    isLoading,
    search,
    onSearch,
    transactions,
    txsByAcc,
    reset,
    pagination,
    filters,
    setFilters,
  };
};
